var map = {
	"./20231218/t1.jpg": 18122,
	"./20231218/t1b.jpg": 37022,
	"./20231218/t2.jpg": 92376,
	"./202405-65.png": 85672,
	"./QR_ERC20.png": 34339,
	"./QR_TRC20.png": 24637,
	"./abg-0.png": 56481,
	"./abg-1.png": 58198,
	"./abg-1b.png": 48094,
	"./abg-2.png": 42240,
	"./abg-3.png": 35118,
	"./abg-4.png": 36051,
	"./abg-5.png": 75012,
	"./abg-6.png": 94366,
	"./avatar/a1.png": 89323,
	"./avatar/a2.png": 85327,
	"./avatar/a3.png": 12845,
	"./avatar/a4.png": 11655,
	"./avatar/a5.png": 56594,
	"./avatar/a6.png": 94578,
	"./avatar/a7.png": 88087,
	"./avatar/a8.png": 2267,
	"./avatar/a9.png": 12264,
	"./bg-ab01.jpg": 33449,
	"./bg-ab01.png": 25473,
	"./bg-ab02.png": 76284,
	"./bg-ab02b.png": 69558,
	"./bg-ab03.png": 65335,
	"./bg-ab04.png": 35085,
	"./bg-ab05.png": 2693,
	"./bg-ab07.png": 21598,
	"./bg-ab07in.png": 11351,
	"./bg-ab08.png": 93996,
	"./bg-ab09.png": 23728,
	"./bg-ab10.png": 28146,
	"./bg-ab11.png": 9609,
	"./bg-ab12.png": 61273,
	"./bg-ab13.png": 46332,
	"./bg-ab13b.png": 31691,
	"./bg-ab14.jpg": 68236,
	"./bg-ab14a.jpg": 24350,
	"./bg-ab14d.jpg": 65781,
	"./bg-ab15.png": 34290,
	"./bg-ab15b.png": 9459,
	"./bg-ab16.jpg": 27858,
	"./bg01.png": 20539,
	"./bg03-a.png": 65350,
	"./bg03.gif": 40302,
	"./bg03.png": 80154,
	"./bg03a-a.png": 77591,
	"./bg03a.png": 22833,
	"./bg03b-a.png": 83917,
	"./bg03b.png": 59626,
	"./bg03c-a.png": 73844,
	"./bg03c.png": 92932,
	"./bg04.png": 71823,
	"./bg05.png": 39692,
	"./bg05b.png": 81649,
	"./bg05c.jpg": 20707,
	"./bg05d.jpeg": 81361,
	"./bg05d.jpg": 26734,
	"./bg05d的副本.jpeg": 46007,
	"./bg05的副本.png": 16178,
	"./bg06.png": 31451,
	"./bg07.png": 83184,
	"./bg07b.png": 93294,
	"./bg08.png": 33736,
	"./bg09.png": 71612,
	"./bg10.png": 99080,
	"./bg100.png": 41024,
	"./bg101.png": 87902,
	"./bg107.png": 99514,
	"./bg108.png": 58799,
	"./bg109.png": 596,
	"./bg11.png": 6394,
	"./bg111.png": 23928,
	"./bg112.png": 30441,
	"./bg113.png": 56497,
	"./bg114.jpg": 76667,
	"./bg121.png": 49149,
	"./bg122.jpg": 88517,
	"./bg124.png": 41029,
	"./bg124b.png": 97480,
	"./bg125.png": 61387,
	"./bg126.png": 60198,
	"./bg127.png": 15268,
	"./bg128.png": 25533,
	"./bg129.png": 80684,
	"./bg130.png": 47603,
	"./bg133.png": 18202,
	"./bg133t-png-png.png": 23898,
	"./bg133t-png.png": 50658,
	"./bg133t.jpg": 67054,
	"./bg133t.png": 60939,
	"./bg134.jpg": 17012,
	"./bg135.png": 40101,
	"./bg136.png": 82961,
	"./bg138.png": 85665,
	"./bg139.png": 87089,
	"./bg140.png": 43595,
	"./bg141.gif": 2240,
	"./bg144.png": 44975,
	"./bg145.jpg": 64221,
	"./bg146.jpg": 77672,
	"./bg147.png": 53906,
	"./bg149.png": 71720,
	"./bg149b.png": 7957,
	"./bg15.png": 92552,
	"./bg150.png": 44520,
	"./bg152-c.png": 46472,
	"./bg152-m.png": 26383,
	"./bg152-p.png": 75698,
	"./bg152-w.png": 17369,
	"./bg15_1225.png": 27076,
	"./bg15_1225b.png": 54788,
	"./bg15c.png": 50271,
	"./bg16.png": 52970,
	"./bg17-1.png": 38853,
	"./bg17-2.png": 3642,
	"./bg17.png": 86851,
	"./bg170.png": 76762,
	"./bg171.png": 90765,
	"./bg18.png": 9498,
	"./bg180.jpg": 75712,
	"./bg180s.jpg": 22859,
	"./bg180w.jpg": 52304,
	"./bg181.jpg": 49443,
	"./bg182.jpg": 3054,
	"./bg182的副本.jpg": 59909,
	"./bg183.png": 85732,
	"./bg184.png": 93244,
	"./bg185.png": 21173,
	"./bg186.png": 1344,
	"./bg186的副本.png": 7105,
	"./bg187.png": 47026,
	"./bg188-1.png": 14070,
	"./bg188-2.png": 48409,
	"./bg188-3.png": 65588,
	"./bg188-4.png": 83762,
	"./bg188-5.png": 86910,
	"./bg188-6.png": 70482,
	"./bg188-7.png": 24462,
	"./bg188-9.png": 17688,
	"./bg188b.png": 57652,
	"./bg189-b.png": 95644,
	"./bg189-r.png": 27510,
	"./bg189-y.png": 73727,
	"./bg190-b.png": 36321,
	"./bg190-r.png": 59352,
	"./bg190-y.png": 42167,
	"./bg191.png": 33098,
	"./bg192.png": 18211,
	"./bg193.png": 1868,
	"./bg194.png": 94214,
	"./bg194b.png": 91646,
	"./bg195.png": 41039,
	"./bg20.jpg": 51769,
	"./bg20.png": 21494,
	"./bg200.png": 10127,
	"./bg201.png": 13019,
	"./bg202.png": 18570,
	"./bg203.png": 35536,
	"./bg204.png": 28913,
	"./bg205.png": 6968,
	"./bg206.png": 80843,
	"./bg207.png": 60959,
	"./bg208.png": 90460,
	"./bg20_1225.png": 38339,
	"./bg20b.jpg": 76889,
	"./bg21.png": 14893,
	"./bg22.png": 43159,
	"./bg23.png": 98452,
	"./bg24.png": 4660,
	"./bg25.png": 78404,
	"./bg26.png": 82005,
	"./bg27.png": 57450,
	"./bg28.png": 33574,
	"./bg30.png": 50265,
	"./bg301.png": 71833,
	"./bg301b.png": 18073,
	"./bg302.png": 83778,
	"./bg303.png": 41142,
	"./bg304.jpg": 45436,
	"./bg305.png": 17581,
	"./bg306.png": 31122,
	"./bg308.png": 69279,
	"./bg309.png": 7736,
	"./bg31.png": 26330,
	"./bg310.png": 29919,
	"./bg311.png": 78884,
	"./bg312.png": 18257,
	"./bg313.png": 7580,
	"./bg314.png": 67467,
	"./bg315.png": 80707,
	"./bg32.png": 5407,
	"./bg33.png": 93632,
	"./bg33b.png": 65148,
	"./bg34.png": 71736,
	"./bg35.png": 55621,
	"./bg36.png": 61344,
	"./bg37.png": 76108,
	"./bg401.jpg": 5070,
	"./bg49.png": 10275,
	"./bg50.png": 90630,
	"./bg500-zoom.jpg": 76773,
	"./bg500.jpg": 56177,
	"./bg501.png": 55486,
	"./bg502.png": 22963,
	"./bg503.png": 65527,
	"./bg504.png": 53404,
	"./bg507.png": 66088,
	"./bg508.png": 42722,
	"./bg51.png": 80873,
	"./bg512.png": 90582,
	"./bg52.png": 52008,
	"./bg57.png": 24826,
	"./bg57d.png": 72257,
	"./bg57e.png": 85070,
	"./bg57f.jpg": 80556,
	"./bg57j.png": 47409,
	"./bg57的副本.png": 44569,
	"./bg58.png": 19655,
	"./bg58b.png": 54941,
	"./bg58c.png": 7324,
	"./bg60.png": 56974,
	"./bg63.png": 92629,
	"./bg64.png": 31992,
	"./bg65.png": 60756,
	"./bg66.gif": 45389,
	"./bg66.png": 12358,
	"./bg72.gif": 15213,
	"./bg77.png": 7614,
	"./bg78.png": 37620,
	"./bg80.jpg": 66903,
	"./bg81.jpg": 9182,
	"./bg81b.jpg": 69015,
	"./bg82.jpg": 70423,
	"./bg84.png": 76217,
	"./bg84b.png": 7071,
	"./bg85.jpg": 87194,
	"./bg87.png": 8346,
	"./bg88.png": 87192,
	"./bg93.png": 88777,
	"./bg93b.png": 99602,
	"./bg95.png": 45763,
	"./bg96.png": 83751,
	"./bg97.png": 12321,
	"./bg98.png": 37743,
	"./bg99.png": 69110,
	"./bg_92.png": 23550,
	"./br/PT/S1/avatar/a1.png": 40867,
	"./br/PT/S1/avatar/a2.png": 9193,
	"./br/PT/S1/avatar/a3.png": 66228,
	"./br/PT/S1/avatar/a4.png": 16505,
	"./br/PT/S1/avatar/a5.png": 56031,
	"./br/PT/S1/avatar/a6.png": 50783,
	"./br/PT/S1/avatar/a7.png": 32982,
	"./br/PT/S1/avatar/a8.png": 69874,
	"./br/PT/S1/avatar/a9.png": 90939,
	"./br/PT/S1/bg-lose.png": 16869,
	"./br/PT/S1/bg-win.png": 7793,
	"./br/PT/S1/bg03-a.png": 10657,
	"./br/PT/S1/bg03-a_1225.png": 57606,
	"./br/PT/S1/bg03.png": 95478,
	"./br/PT/S1/bg03_1225.png": 94989,
	"./br/PT/S1/bg05c.jpg": 25059,
	"./br/PT/S1/bg07 - 副本.png": 15970,
	"./br/PT/S1/bg07.png": 41817,
	"./br/PT/S1/bg07b - 副本.png": 673,
	"./br/PT/S1/bg07b.png": 73231,
	"./br/PT/S1/bg105.png": 10605,
	"./br/PT/S1/bg115.png": 45260,
	"./br/PT/S1/bg116.png": 48296,
	"./br/PT/S1/bg117.png": 45641,
	"./br/PT/S1/bg13.png": 9374,
	"./br/PT/S1/bg130.png": 15710,
	"./br/PT/S1/bg131.png": 16165,
	"./br/PT/S1/bg132.png": 98637,
	"./br/PT/S1/bg142.png": 91880,
	"./br/PT/S1/bg143.png": 37680,
	"./br/PT/S1/bg145.jpg": 70961,
	"./br/PT/S1/bg147.jpg": 93548,
	"./br/PT/S1/bg148.jpg": 95239,
	"./br/PT/S1/bg149.jpg": 5064,
	"./br/PT/S1/bg150.jpg": 53553,
	"./br/PT/S1/bg155.jpg": 1521,
	"./br/PT/S1/bg180.jpg": 91104,
	"./br/PT/S1/bg180s.jpg": 51372,
	"./br/PT/S1/bg180w.jpg": 29477,
	"./br/PT/S1/bg182.jpg": 44189,
	"./br/PT/S1/bg185.png": 69669,
	"./br/PT/S1/bg20.jpg": 81891,
	"./br/PT/S1/bg300.png": 31866,
	"./br/PT/S1/bg301.png": 68573,
	"./br/PT/S1/bg53.png": 48088,
	"./br/PT/S1/bg54.jpg": 5337,
	"./br/PT/S1/bg55.png": 57922,
	"./br/PT/S1/bg59.png": 30928,
	"./br/PT/S1/bg62.png": 14402,
	"./br/PT/S1/bg67.png": 56286,
	"./br/PT/S1/bg67b.png": 50568,
	"./br/PT/S1/bg67c.png": 29395,
	"./br/PT/S1/bg68.jpg": 11724,
	"./br/PT/S1/bg69.jpg": 95489,
	"./br/PT/S1/bg70.jpg": 42068,
	"./br/PT/S1/bg76.png": 46027,
	"./br/PT/S1/bg79.jpg": 22029,
	"./br/PT/S1/bg901.png": 7379,
	"./br/PT/S1/bg903.jpg": 51375,
	"./br/PT/S1/bg903.png": 11143,
	"./br/PT/S1/bg_crash.png": 71326,
	"./br/PT/S1/bg_mine.png": 4440,
	"./br/PT/S1/bg_p115.jpg": 88605,
	"./br/PT/S1/bg_p117.jpg": 66172,
	"./br/PT/S1/bg_p118.jpg": 66555,
	"./br/PT/S1/bg_p119.jpg": 21972,
	"./br/PT/S1/bg_p120.jpg": 38338,
	"./br/PT/S1/bg_p123.jpg": 21427,
	"./br/PT/S1/bg_p125.jpg": 78934,
	"./br/PT/S1/bg_parity.png": 35445,
	"./br/PT/S1/bigwin.png": 63401,
	"./br/PT/S1/fj.png": 46883,
	"./br/PT/S1/fj2.png": 35541,
	"./br/PT/S1/fjbg.jpg": 75937,
	"./br/PT/S1/fjbg2.jpg": 4028,
	"./br/PT/S1/fjbg6.png": 36897,
	"./br/PT/S1/fjd.gif": 72543,
	"./br/PT/S1/fjf.gif": 68827,
	"./br/PT/S1/gm1.png": 48679,
	"./br/PT/S1/gm2.png": 17709,
	"./br/PT/S1/gm3.png": 32246,
	"./br/PT/S1/gm4.png": 1364,
	"./br/PT/S1/gm5.png": 28457,
	"./br/PT/S1/gm6.png": 20404,
	"./br/PT/S1/play.gif": 33350,
	"./br/PT/S1/toplogo.png": 34294,
	"./br/PT/S2/avatar/a1.png": 98692,
	"./br/PT/S2/avatar/a2.png": 52499,
	"./br/PT/S2/avatar/a3.png": 65574,
	"./br/PT/S2/avatar/a4.png": 44151,
	"./br/PT/S2/avatar/a5.png": 15515,
	"./br/PT/S2/avatar/a6.png": 43860,
	"./br/PT/S2/avatar/a7.png": 38708,
	"./br/PT/S2/avatar/a8.png": 52151,
	"./br/PT/S2/avatar/a9.png": 35960,
	"./br/PT/S2/bg-loginbg.png": 96298,
	"./br/PT/S2/bg-lose.png": 84652,
	"./br/PT/S2/bg-win.png": 19718,
	"./br/PT/S2/bg01.png": 18529,
	"./br/PT/S2/bg03-a.png": 47630,
	"./br/PT/S2/bg03-a_1225.png": 11567,
	"./br/PT/S2/bg03.png": 39431,
	"./br/PT/S2/bg03_1225.png": 21720,
	"./br/PT/S2/bg05c.jpg": 78494,
	"./br/PT/S2/bg05d.jpg": 42090,
	"./br/PT/S2/bg07.png": 24477,
	"./br/PT/S2/bg07b.png": 40955,
	"./br/PT/S2/bg10.png": 95228,
	"./br/PT/S2/bg100.png": 60531,
	"./br/PT/S2/bg101.png": 17555,
	"./br/PT/S2/bg105.png": 31593,
	"./br/PT/S2/bg108.png": 76926,
	"./br/PT/S2/bg11.png": 16051,
	"./br/PT/S2/bg115.png": 83884,
	"./br/PT/S2/bg116.png": 11054,
	"./br/PT/S2/bg117.png": 52743,
	"./br/PT/S2/bg128.png": 81312,
	"./br/PT/S2/bg129.png": 38106,
	"./br/PT/S2/bg13.png": 86611,
	"./br/PT/S2/bg130.png": 52487,
	"./br/PT/S2/bg131.png": 39852,
	"./br/PT/S2/bg132.png": 7380,
	"./br/PT/S2/bg135.png": 12126,
	"./br/PT/S2/bg142.png": 28514,
	"./br/PT/S2/bg143.png": 95713,
	"./br/PT/S2/bg145.jpg": 46031,
	"./br/PT/S2/bg147.jpg": 58,
	"./br/PT/S2/bg148.jpg": 80131,
	"./br/PT/S2/bg149.jpg": 89494,
	"./br/PT/S2/bg15.png": 21416,
	"./br/PT/S2/bg150.jpg": 53988,
	"./br/PT/S2/bg155.jpg": 23056,
	"./br/PT/S2/bg17-2.png": 86236,
	"./br/PT/S2/bg17.png": 97074,
	"./br/PT/S2/bg180.jpg": 54005,
	"./br/PT/S2/bg180s.jpg": 40433,
	"./br/PT/S2/bg180w.jpg": 83854,
	"./br/PT/S2/bg181.jpg": 52277,
	"./br/PT/S2/bg182.jpg": 62198,
	"./br/PT/S2/bg182b.png": 22129,
	"./br/PT/S2/bg184.png": 50379,
	"./br/PT/S2/bg185.png": 38874,
	"./br/PT/S2/bg186.png": 53754,
	"./br/PT/S2/bg188-9.png": 47107,
	"./br/PT/S2/bg188.png": 40322,
	"./br/PT/S2/bg189-b.png": 15928,
	"./br/PT/S2/bg189-r.png": 11384,
	"./br/PT/S2/bg189-y.png": 82413,
	"./br/PT/S2/bg190-b.png": 15524,
	"./br/PT/S2/bg190-r.png": 28444,
	"./br/PT/S2/bg190-y.png": 83167,
	"./br/PT/S2/bg193.png": 14872,
	"./br/PT/S2/bg199.png": 2495,
	"./br/PT/S2/bg199b.png": 98670,
	"./br/PT/S2/bg199c.png": 16648,
	"./br/PT/S2/bg20.jpg": 22527,
	"./br/PT/S2/bg200.png": 91411,
	"./br/PT/S2/bg201.png": 84532,
	"./br/PT/S2/bg202.png": 85773,
	"./br/PT/S2/bg203.png": 13191,
	"./br/PT/S2/bg204.png": 73190,
	"./br/PT/S2/bg30.png": 20392,
	"./br/PT/S2/bg301.png": 1479,
	"./br/PT/S2/bg31.png": 47199,
	"./br/PT/S2/bg32.png": 58913,
	"./br/PT/S2/bg33.png": 11856,
	"./br/PT/S2/bg34.png": 79977,
	"./br/PT/S2/bg35.png": 90239,
	"./br/PT/S2/bg36.png": 3525,
	"./br/PT/S2/bg36b.png": 92314,
	"./br/PT/S2/bg39.png": 81368,
	"./br/PT/S2/bg40.png": 66311,
	"./br/PT/S2/bg41.png": 9050,
	"./br/PT/S2/bg42.png": 21406,
	"./br/PT/S2/bg43.png": 77604,
	"./br/PT/S2/bg44.png": 40136,
	"./br/PT/S2/bg45.png": 1688,
	"./br/PT/S2/bg46.png": 9616,
	"./br/PT/S2/bg47.png": 59057,
	"./br/PT/S2/bg48.png": 13381,
	"./br/PT/S2/bg49.png": 81116,
	"./br/PT/S2/bg49b.png": 5964,
	"./br/PT/S2/bg53.png": 38352,
	"./br/PT/S2/bg54.jpg": 10753,
	"./br/PT/S2/bg55.png": 99415,
	"./br/PT/S2/bg57.png": 42623,
	"./br/PT/S2/bg59.png": 91277,
	"./br/PT/S2/bg60.png": 30394,
	"./br/PT/S2/bg62.png": 88275,
	"./br/PT/S2/bg67.png": 71782,
	"./br/PT/S2/bg67b.png": 13633,
	"./br/PT/S2/bg67c.png": 75942,
	"./br/PT/S2/bg67d.jpg": 76609,
	"./br/PT/S2/bg68.jpg": 41302,
	"./br/PT/S2/bg69.jpg": 95014,
	"./br/PT/S2/bg70.jpg": 90955,
	"./br/PT/S2/bg76.png": 88215,
	"./br/PT/S2/bg79.jpg": 4395,
	"./br/PT/S2/bg80.jpg": 4627,
	"./br/PT/S2/bg81.jpg": 5660,
	"./br/PT/S2/bg85.jpg": 65977,
	"./br/PT/S2/bg87.png": 27122,
	"./br/PT/S2/bg903.jpg": 8234,
	"./br/PT/S2/bg93.png": 50705,
	"./br/PT/S2/bg93b.png": 21777,
	"./br/PT/S2/bg95.png": 8143,
	"./br/PT/S2/bg97.png": 11077,
	"./br/PT/S2/bg98.png": 61407,
	"./br/PT/S2/bg98b.png": 42648,
	"./br/PT/S2/bg999.png": 95193,
	"./br/PT/S2/bg_crash.png": 1068,
	"./br/PT/S2/bg_mine.png": 5911,
	"./br/PT/S2/bg_p115.jpg": 4842,
	"./br/PT/S2/bg_p117.jpg": 50722,
	"./br/PT/S2/bg_p118.jpg": 41468,
	"./br/PT/S2/bg_p119.jpg": 29680,
	"./br/PT/S2/bg_p120.jpg": 47068,
	"./br/PT/S2/bg_p123.jpg": 30377,
	"./br/PT/S2/bg_p125.jpg": 70878,
	"./br/PT/S2/bg_parity.png": 97932,
	"./br/PT/S2/bigwin.png": 11654,
	"./br/PT/S2/fj.png": 11488,
	"./br/PT/S2/fj2.png": 42093,
	"./br/PT/S2/fjbg.jpg": 60203,
	"./br/PT/S2/fjbg2.jpg": 43810,
	"./br/PT/S2/fjbg2.png": 84568,
	"./br/PT/S2/fjbg6.png": 99488,
	"./br/PT/S2/fjd.gif": 53566,
	"./br/PT/S2/fjf.gif": 34905,
	"./br/PT/S2/fjf.jpg": 11239,
	"./br/PT/S2/fjjb.png": 80459,
	"./br/PT/S2/gm1.png": 13338,
	"./br/PT/S2/gm2.png": 44433,
	"./br/PT/S2/gm3.png": 34668,
	"./br/PT/S2/gm4.png": 70714,
	"./br/PT/S2/gm5.png": 19416,
	"./br/PT/S2/icon-01.png": 35466,
	"./br/PT/S2/icon-02.png": 16982,
	"./br/PT/S2/play.gif": 1773,
	"./br/PT/S2/toplogo.png": 56608,
	"./br/PT/bg-lose.png": 7337,
	"./br/PT/bg-win.png": 26877,
	"./br/PT/bg03-a.png": 67397,
	"./br/PT/bg03-a_1225.png": 98621,
	"./br/PT/bg03.png": 50906,
	"./br/PT/bg03_1225.png": 84442,
	"./br/PT/bg05c.jpg": 80425,
	"./br/PT/bg105.png": 74143,
	"./br/PT/bg115.png": 90212,
	"./br/PT/bg116.png": 95836,
	"./br/PT/bg117.png": 55658,
	"./br/PT/bg13.png": 78443,
	"./br/PT/bg131.png": 98480,
	"./br/PT/bg132.png": 33420,
	"./br/PT/bg142.png": 74652,
	"./br/PT/bg143.png": 32462,
	"./br/PT/bg147.jpg": 23225,
	"./br/PT/bg148.jpg": 87867,
	"./br/PT/bg149.jpg": 33668,
	"./br/PT/bg150.jpg": 42197,
	"./br/PT/bg155.jpg": 10843,
	"./br/PT/bg53.png": 98531,
	"./br/PT/bg54.jpg": 23771,
	"./br/PT/bg55.png": 86701,
	"./br/PT/bg59.png": 9758,
	"./br/PT/bg60.png": 17996,
	"./br/PT/bg62.png": 59749,
	"./br/PT/bg67.png": 99334,
	"./br/PT/bg67b.png": 41490,
	"./br/PT/bg67c.png": 96226,
	"./br/PT/bg68.jpg": 17762,
	"./br/PT/bg69.jpg": 21124,
	"./br/PT/bg70.jpg": 17515,
	"./br/PT/bg76.png": 27198,
	"./br/PT/bg79.jpg": 53299,
	"./br/PT/bg903.jpg": 80834,
	"./br/PT/bg_crash.png": 11971,
	"./br/PT/bg_mine.png": 33820,
	"./br/PT/bg_p115.jpg": 97367,
	"./br/PT/bg_p117.jpg": 91393,
	"./br/PT/bg_p118.jpg": 90902,
	"./br/PT/bg_p119.jpg": 48219,
	"./br/PT/bg_p120.jpg": 6565,
	"./br/PT/bg_p123.jpg": 79412,
	"./br/PT/bg_p125.jpg": 87675,
	"./br/PT/bg_parity.png": 27975,
	"./br/PT/fjf.gif": 61873,
	"./br/PT/play.gif": 76606,
	"./br/PT/toplogo.png": 10363,
	"./fj.png": 44493,
	"./fj2.png": 81519,
	"./fj3.png": 51951,
	"./fjbg.jpg": 24969,
	"./fjbg2.jpg": 45999,
	"./fjbg6.png": 97414,
	"./fjbz.png": 70481,
	"./fjc.png": 63713,
	"./fjd.gif": 89148,
	"./fje.gif": 93033,
	"./fjf.png": 78568,
	"./fjjb.gif": 24183,
	"./fjjb.png": 50877,
	"./fjyw-r.png": 16105,
	"./gm1.png": 55003,
	"./gm2.png": 14990,
	"./gm3.png": 56629,
	"./gm4.png": 536,
	"./gm5.png": 63189,
	"./gm6.png": 7097,
	"./goglePlay.jpg": 32555,
	"./images_ui_item_selected.png": 20517,
	"./img24.png": 28946,
	"./img25.png": 45907,
	"./in/EN/S1/avatar/a1.png": 35943,
	"./in/EN/S1/avatar/a2.png": 2404,
	"./in/EN/S1/avatar/a3.png": 94343,
	"./in/EN/S1/avatar/a4.png": 94248,
	"./in/EN/S1/avatar/a5.png": 51198,
	"./in/EN/S1/avatar/a6.png": 62087,
	"./in/EN/S1/avatar/a7.png": 92119,
	"./in/EN/S1/avatar/a8.png": 85295,
	"./in/EN/S1/avatar/a9.png": 50020,
	"./in/EN/S1/bg05b.jpg": 83476,
	"./in/EN/S1/bg05c.jpg": 67518,
	"./in/EN/S1/bg05d.jpg": 60746,
	"./in/EN/S1/bg07.png": 6838,
	"./in/EN/S1/bg07b.png": 19313,
	"./in/EN/S1/bg105.png": 47229,
	"./in/EN/S1/bg115.png": 19824,
	"./in/EN/S1/bg116.png": 93603,
	"./in/EN/S1/bg117.png": 11220,
	"./in/EN/S1/bg128.png": 30454,
	"./in/EN/S1/bg129.png": 57446,
	"./in/EN/S1/bg13.png": 27013,
	"./in/EN/S1/bg130.png": 23157,
	"./in/EN/S1/bg145.jpg": 28814,
	"./in/EN/S1/bg147.jpg": 10143,
	"./in/EN/S1/bg148.jpg": 54722,
	"./in/EN/S1/bg149.jpg": 81895,
	"./in/EN/S1/bg150.jpg": 92648,
	"./in/EN/S1/bg152-w.png": 76148,
	"./in/EN/S1/bg155.jpg": 30792,
	"./in/EN/S1/bg180.jpg": 84362,
	"./in/EN/S1/bg180s.jpg": 760,
	"./in/EN/S1/bg180w.jpg": 88639,
	"./in/EN/S1/bg181.jpg": 42260,
	"./in/EN/S1/bg182.jpg": 12620,
	"./in/EN/S1/bg184.png": 33871,
	"./in/EN/S1/bg185.png": 64849,
	"./in/EN/S1/bg20.jpg": 95349,
	"./in/EN/S1/bg300.png": 94496,
	"./in/EN/S1/bg301.png": 63284,
	"./in/EN/S1/bg53.png": 14501,
	"./in/EN/S1/bg62.png": 12800,
	"./in/EN/S1/bg67.png": 95161,
	"./in/EN/S1/bg67b.png": 83306,
	"./in/EN/S1/bg67c.png": 63953,
	"./in/EN/S1/bg68.jpg": 44528,
	"./in/EN/S1/bg69.jpg": 48453,
	"./in/EN/S1/bg70.jpg": 16835,
	"./in/EN/S1/bg76.png": 14505,
	"./in/EN/S1/bg901.jpg": 84925,
	"./in/EN/S1/bg902.jpg": 31425,
	"./in/EN/S1/bg903.jpg": 28284,
	"./in/EN/S1/bg_p115.jpg": 87582,
	"./in/EN/S1/bg_p117.jpg": 33603,
	"./in/EN/S1/bg_p118.jpg": 17695,
	"./in/EN/S1/bg_p119.jpg": 47430,
	"./in/EN/S1/bg_p120.jpg": 37519,
	"./in/EN/S1/bg_p123.jpg": 41333,
	"./in/EN/S1/bg_p125.jpg": 90265,
	"./in/EN/S1/bigwin.png": 31273,
	"./in/EN/S1/fj.png": 64080,
	"./in/EN/S1/fj2.png": 79144,
	"./in/EN/S1/fjbg.jpg": 75705,
	"./in/EN/S1/fjbg2.jpg": 5801,
	"./in/EN/S1/fjbg6.png": 64805,
	"./in/EN/S1/fjd.gif": 60834,
	"./in/EN/S1/ggdown.jpg": 82265,
	"./in/EN/S1/gm1.png": 15903,
	"./in/EN/S1/gm2.png": 64122,
	"./in/EN/S1/gm3.png": 75324,
	"./in/EN/S1/gm4.png": 74367,
	"./in/EN/S1/gm5.png": 62321,
	"./in/EN/S1/gm6.png": 9586,
	"./in/EN/S1/play.gif": 80349,
	"./in/EN/S2/avatar/a1.png": 27327,
	"./in/EN/S2/avatar/a2.png": 34916,
	"./in/EN/S2/avatar/a3.png": 64393,
	"./in/EN/S2/avatar/a4.png": 86590,
	"./in/EN/S2/avatar/a5.png": 16912,
	"./in/EN/S2/avatar/a6.png": 72072,
	"./in/EN/S2/avatar/a7.png": 78310,
	"./in/EN/S2/avatar/a8.png": 89488,
	"./in/EN/S2/avatar/a9.png": 42182,
	"./in/EN/S2/bg-loginbg.png": 8091,
	"./in/EN/S2/bg-loginbg2.png": 98423,
	"./in/EN/S2/bg-loginbg3.png": 93424,
	"./in/EN/S2/bg-loginbg4.png": 49793,
	"./in/EN/S2/bg-lose.png": 57914,
	"./in/EN/S2/bg-win.png": 273,
	"./in/EN/S2/bg01.png": 61256,
	"./in/EN/S2/bg03-a.png": 17191,
	"./in/EN/S2/bg03-a_1225.png": 34352,
	"./in/EN/S2/bg03.png": 26243,
	"./in/EN/S2/bg03_1225.png": 19498,
	"./in/EN/S2/bg05c.jpg": 26334,
	"./in/EN/S2/bg05d.jpg": 86733,
	"./in/EN/S2/bg07.png": 3375,
	"./in/EN/S2/bg07b.png": 82968,
	"./in/EN/S2/bg10.png": 96310,
	"./in/EN/S2/bg100.png": 70001,
	"./in/EN/S2/bg101.png": 2493,
	"./in/EN/S2/bg105.png": 330,
	"./in/EN/S2/bg11.png": 96656,
	"./in/EN/S2/bg115.png": 70954,
	"./in/EN/S2/bg116.png": 71917,
	"./in/EN/S2/bg117.png": 70759,
	"./in/EN/S2/bg128.png": 82072,
	"./in/EN/S2/bg129.png": 92599,
	"./in/EN/S2/bg13.png": 65479,
	"./in/EN/S2/bg130.png": 50970,
	"./in/EN/S2/bg131.png": 39372,
	"./in/EN/S2/bg132.png": 31453,
	"./in/EN/S2/bg135.png": 6606,
	"./in/EN/S2/bg142.png": 51631,
	"./in/EN/S2/bg143.png": 72308,
	"./in/EN/S2/bg145.jpg": 81330,
	"./in/EN/S2/bg147.jpg": 37384,
	"./in/EN/S2/bg148.jpg": 52942,
	"./in/EN/S2/bg149.jpg": 90800,
	"./in/EN/S2/bg15.png": 91851,
	"./in/EN/S2/bg150.jpg": 51263,
	"./in/EN/S2/bg152-w.png": 3551,
	"./in/EN/S2/bg155.jpg": 82620,
	"./in/EN/S2/bg17-2.png": 43356,
	"./in/EN/S2/bg17.png": 62946,
	"./in/EN/S2/bg180.jpg": 67555,
	"./in/EN/S2/bg180s.jpg": 43921,
	"./in/EN/S2/bg180w.jpg": 22115,
	"./in/EN/S2/bg181.jpg": 44210,
	"./in/EN/S2/bg182.jpg": 60324,
	"./in/EN/S2/bg182b.png": 45740,
	"./in/EN/S2/bg184.png": 61383,
	"./in/EN/S2/bg185.png": 95487,
	"./in/EN/S2/bg186.png": 62257,
	"./in/EN/S2/bg188-9.png": 63790,
	"./in/EN/S2/bg188.png": 78039,
	"./in/EN/S2/bg189-b.png": 22004,
	"./in/EN/S2/bg189-r.png": 4372,
	"./in/EN/S2/bg189-y.png": 11123,
	"./in/EN/S2/bg190-b.png": 88682,
	"./in/EN/S2/bg190-r.png": 77703,
	"./in/EN/S2/bg190-y.png": 68227,
	"./in/EN/S2/bg193.png": 54973,
	"./in/EN/S2/bg199.png": 25693,
	"./in/EN/S2/bg199b.png": 45930,
	"./in/EN/S2/bg199c.png": 98422,
	"./in/EN/S2/bg199f.png": 80325,
	"./in/EN/S2/bg199h.png": 95820,
	"./in/EN/S2/bg20.jpg": 46873,
	"./in/EN/S2/bg200.png": 66958,
	"./in/EN/S2/bg201.png": 54145,
	"./in/EN/S2/bg202.png": 73539,
	"./in/EN/S2/bg205.png": 2840,
	"./in/EN/S2/bg30.png": 24836,
	"./in/EN/S2/bg301.png": 16921,
	"./in/EN/S2/bg31.png": 46728,
	"./in/EN/S2/bg32.png": 16760,
	"./in/EN/S2/bg33.png": 14198,
	"./in/EN/S2/bg34.png": 37622,
	"./in/EN/S2/bg35.png": 21261,
	"./in/EN/S2/bg36.png": 58848,
	"./in/EN/S2/bg36b.png": 4120,
	"./in/EN/S2/bg39.png": 52847,
	"./in/EN/S2/bg40.png": 42634,
	"./in/EN/S2/bg41.png": 33114,
	"./in/EN/S2/bg42.png": 16945,
	"./in/EN/S2/bg43.png": 30761,
	"./in/EN/S2/bg44.png": 82234,
	"./in/EN/S2/bg45.png": 89739,
	"./in/EN/S2/bg46.png": 67917,
	"./in/EN/S2/bg47.png": 20296,
	"./in/EN/S2/bg48.png": 70460,
	"./in/EN/S2/bg49.png": 43511,
	"./in/EN/S2/bg49b.png": 2569,
	"./in/EN/S2/bg53.png": 48254,
	"./in/EN/S2/bg54.jpg": 44098,
	"./in/EN/S2/bg55.png": 96375,
	"./in/EN/S2/bg57.png": 61478,
	"./in/EN/S2/bg59.png": 89275,
	"./in/EN/S2/bg60.png": 88479,
	"./in/EN/S2/bg62.png": 60149,
	"./in/EN/S2/bg67.png": 8474,
	"./in/EN/S2/bg67b.png": 7608,
	"./in/EN/S2/bg67c.png": 834,
	"./in/EN/S2/bg67d-250.jpg": 53952,
	"./in/EN/S2/bg67d.jpg": 61268,
	"./in/EN/S2/bg68.jpg": 21663,
	"./in/EN/S2/bg69.jpg": 82156,
	"./in/EN/S2/bg70.jpg": 91009,
	"./in/EN/S2/bg76.png": 72978,
	"./in/EN/S2/bg76b.png": 49381,
	"./in/EN/S2/bg79.jpg": 82067,
	"./in/EN/S2/bg80.jpg": 55065,
	"./in/EN/S2/bg81.jpg": 69540,
	"./in/EN/S2/bg85.jpg": 85947,
	"./in/EN/S2/bg87.png": 16100,
	"./in/EN/S2/bg93.png": 32364,
	"./in/EN/S2/bg93b.png": 49278,
	"./in/EN/S2/bg95.png": 61555,
	"./in/EN/S2/bg97.png": 22703,
	"./in/EN/S2/bg97b.png": 86,
	"./in/EN/S2/bg98.png": 28715,
	"./in/EN/S2/bg98b.png": 99735,
	"./in/EN/S2/bg999.png": 19300,
	"./in/EN/S2/bg_crash.png": 1077,
	"./in/EN/S2/bg_mine.png": 93812,
	"./in/EN/S2/bg_p115.jpg": 25868,
	"./in/EN/S2/bg_p117.jpg": 60747,
	"./in/EN/S2/bg_p118.jpg": 97404,
	"./in/EN/S2/bg_p119.jpg": 12693,
	"./in/EN/S2/bg_p120.jpg": 40199,
	"./in/EN/S2/bg_p123.jpg": 19197,
	"./in/EN/S2/bg_p125.jpg": 51987,
	"./in/EN/S2/bg_parity.png": 53257,
	"./in/EN/S2/bigwin.png": 58230,
	"./in/EN/S2/fj.png": 31481,
	"./in/EN/S2/fj2.png": 20975,
	"./in/EN/S2/fj3.gif": 69233,
	"./in/EN/S2/fj3.png": 47466,
	"./in/EN/S2/fjbg.jpg": 6475,
	"./in/EN/S2/fjbg2.png": 37721,
	"./in/EN/S2/fjd.gif": 51891,
	"./in/EN/S2/fjf.jpg": 48879,
	"./in/EN/S2/fjjb.png": 49153,
	"./in/EN/S2/gm1.png": 72018,
	"./in/EN/S2/gm2.png": 27982,
	"./in/EN/S2/gm3.png": 51689,
	"./in/EN/S2/gm4.png": 87621,
	"./in/EN/S2/icon-01.png": 18943,
	"./in/EN/S2/icon-02.png": 51281,
	"./in/EN/S2/play.gif": 13839,
	"./in/EN/S2/toplogo.png": 26466,
	"./in/EN/bg-lose.png": 96093,
	"./in/EN/bg-win.png": 72450,
	"./in/EN/bg05c.jpg": 74421,
	"./in/EN/bg05c2.jpg": 38698,
	"./in/EN/bg115.png": 41463,
	"./in/EN/bg116.png": 36378,
	"./in/EN/bg117.png": 66926,
	"./in/EN/bg13.png": 81881,
	"./in/EN/bg131.png": 97757,
	"./in/EN/bg132.png": 36082,
	"./in/EN/bg142.png": 8488,
	"./in/EN/bg143.png": 49095,
	"./in/EN/bg54.jpg": 65043,
	"./in/EN/bg54的副本.jpg": 54570,
	"./in/EN/bg55.png": 5215,
	"./in/EN/bg59.png": 45111,
	"./in/EN/bg62.png": 48930,
	"./in/EN/bg62的副本.png": 8024,
	"./in/EN/bg79.jpg": 4891,
	"./in/EN/bg_crash.png": 80262,
	"./in/EN/bg_mine.png": 81294,
	"./in/EN/bg_parity.png": 69808,
	"./in/EN/bg_wheel.png": 38586,
	"./in/EN/fjf.gif": 66820,
	"./in/EN/play.gif": 96579,
	"./in/EN/toplogo.png": 76533,
	"./in/HI/S1/bg20.jpg": 5617,
	"./in/HI/bg-lose.png": 60794,
	"./in/HI/bg-win.png": 99652,
	"./in/HI/bg03-a.png": 36628,
	"./in/HI/bg03.png": 50140,
	"./in/HI/bg05c.jpg": 70656,
	"./in/HI/bg105.png": 42527,
	"./in/HI/bg115.png": 24267,
	"./in/HI/bg116.png": 60843,
	"./in/HI/bg117.png": 46622,
	"./in/HI/bg13.png": 95480,
	"./in/HI/bg131.png": 11172,
	"./in/HI/bg132.png": 93423,
	"./in/HI/bg142.png": 43280,
	"./in/HI/bg143.png": 84649,
	"./in/HI/bg147.jpg": 35162,
	"./in/HI/bg148.jpg": 1613,
	"./in/HI/bg149.jpg": 84897,
	"./in/HI/bg150.jpg": 57655,
	"./in/HI/bg155.jpg": 37842,
	"./in/HI/bg53.png": 13768,
	"./in/HI/bg54.jpg": 54169,
	"./in/HI/bg55.png": 50609,
	"./in/HI/bg59.png": 86390,
	"./in/HI/bg62.png": 19843,
	"./in/HI/bg67.png": 73483,
	"./in/HI/bg67b.png": 68652,
	"./in/HI/bg67c.png": 40962,
	"./in/HI/bg68.jpg": 33541,
	"./in/HI/bg69.jpg": 11999,
	"./in/HI/bg70.jpg": 44272,
	"./in/HI/bg76.png": 62035,
	"./in/HI/bg79.jpg": 48974,
	"./in/HI/bg_crash.png": 53090,
	"./in/HI/bg_mine.png": 38382,
	"./in/HI/bg_p115.jpg": 18099,
	"./in/HI/bg_p117.jpg": 89096,
	"./in/HI/bg_p118.jpg": 10952,
	"./in/HI/bg_p119.jpg": 71237,
	"./in/HI/bg_p120.jpg": 66477,
	"./in/HI/bg_p123.jpg": 41758,
	"./in/HI/bg_p125.jpg": 11774,
	"./in/HI/bg_parity.png": 81403,
	"./in/HI/fjf.gif": 92312,
	"./in/HI/play.gif": 36520,
	"./in/HI/toplogo.png": 32667,
	"./mx/EN/S1/avatar/a1.png": 35998,
	"./mx/EN/S1/avatar/a2.png": 92204,
	"./mx/EN/S1/avatar/a3.png": 32019,
	"./mx/EN/S1/avatar/a4.png": 46092,
	"./mx/EN/S1/avatar/a5.png": 8834,
	"./mx/EN/S1/avatar/a6.png": 111,
	"./mx/EN/S1/avatar/a7.png": 35259,
	"./mx/EN/S1/avatar/a8.png": 49457,
	"./mx/EN/S1/avatar/a9.png": 47152,
	"./mx/EN/S1/bg03-a.png": 31713,
	"./mx/EN/S1/bg03.png": 10852,
	"./mx/EN/S1/bg07.png": 96716,
	"./mx/EN/S1/bg07b.png": 60424,
	"./mx/EN/S1/bg105.png": 34647,
	"./mx/EN/S1/bg115.png": 84271,
	"./mx/EN/S1/bg116.png": 58466,
	"./mx/EN/S1/bg117.png": 78654,
	"./mx/EN/S1/bg13.png": 80700,
	"./mx/EN/S1/bg131.png": 50472,
	"./mx/EN/S1/bg132.png": 69525,
	"./mx/EN/S1/bg145.jpg": 32707,
	"./mx/EN/S1/bg147.jpg": 58780,
	"./mx/EN/S1/bg148.jpg": 4321,
	"./mx/EN/S1/bg149.jpg": 16398,
	"./mx/EN/S1/bg150.jpg": 57283,
	"./mx/EN/S1/bg155.jpg": 44114,
	"./mx/EN/S1/bg180.jpg": 60015,
	"./mx/EN/S1/bg180s.jpg": 77039,
	"./mx/EN/S1/bg180w.jpg": 51967,
	"./mx/EN/S1/bg181.jpg": 7103,
	"./mx/EN/S1/bg182.jpg": 16016,
	"./mx/EN/S1/bg184.png": 96117,
	"./mx/EN/S1/bg185.png": 79175,
	"./mx/EN/S1/bg20.jpg": 39155,
	"./mx/EN/S1/bg301.png": 89898,
	"./mx/EN/S1/bg53.png": 80667,
	"./mx/EN/S1/bg59.png": 71539,
	"./mx/EN/S1/bg62.png": 51825,
	"./mx/EN/S1/bg67.png": 60158,
	"./mx/EN/S1/bg67b.png": 11669,
	"./mx/EN/S1/bg67c.png": 29845,
	"./mx/EN/S1/bg68.jpg": 36120,
	"./mx/EN/S1/bg69.jpg": 37000,
	"./mx/EN/S1/bg70.jpg": 11242,
	"./mx/EN/S1/bg76.png": 61733,
	"./mx/EN/S1/bg_p115.jpg": 9025,
	"./mx/EN/S1/bg_p117.jpg": 62984,
	"./mx/EN/S1/bg_p118.jpg": 53928,
	"./mx/EN/S1/bg_p119.jpg": 79225,
	"./mx/EN/S1/bg_p120.jpg": 22111,
	"./mx/EN/S1/bg_p123.jpg": 61578,
	"./mx/EN/S1/bg_p125.jpg": 61190,
	"./mx/EN/S1/fjbg.jpg": 86415,
	"./mx/EN/S1/gm1.png": 36876,
	"./mx/EN/S1/gm2.png": 69726,
	"./mx/EN/S1/gm3.png": 8449,
	"./mx/EN/S1/gm4.png": 66634,
	"./mx/EN/bg-lose.png": 80142,
	"./mx/EN/bg-win.png": 76909,
	"./mx/EN/bg03-a.png": 38388,
	"./mx/EN/bg03.png": 84437,
	"./mx/EN/bg05c.jpg": 45547,
	"./mx/EN/bg105.png": 2696,
	"./mx/EN/bg115.png": 8356,
	"./mx/EN/bg116.png": 35954,
	"./mx/EN/bg117.png": 9334,
	"./mx/EN/bg13.png": 11759,
	"./mx/EN/bg131.png": 59468,
	"./mx/EN/bg132.png": 66166,
	"./mx/EN/bg142.png": 69321,
	"./mx/EN/bg143.png": 14239,
	"./mx/EN/bg147.jpg": 40134,
	"./mx/EN/bg148.jpg": 92756,
	"./mx/EN/bg149.jpg": 8595,
	"./mx/EN/bg150.jpg": 17566,
	"./mx/EN/bg155.jpg": 67623,
	"./mx/EN/bg53.png": 95680,
	"./mx/EN/bg54.jpg": 54484,
	"./mx/EN/bg55.png": 18740,
	"./mx/EN/bg59.png": 56771,
	"./mx/EN/bg62.png": 8520,
	"./mx/EN/bg67.png": 69266,
	"./mx/EN/bg67b.png": 80311,
	"./mx/EN/bg67c.png": 97897,
	"./mx/EN/bg68.jpg": 70972,
	"./mx/EN/bg69.jpg": 48765,
	"./mx/EN/bg70.jpg": 88701,
	"./mx/EN/bg76.png": 29523,
	"./mx/EN/bg79.jpg": 86978,
	"./mx/EN/bg_crash.png": 30803,
	"./mx/EN/bg_mine.png": 91898,
	"./mx/EN/bg_p115.jpg": 11459,
	"./mx/EN/bg_p117.jpg": 63107,
	"./mx/EN/bg_p118.jpg": 5554,
	"./mx/EN/bg_p119.jpg": 78938,
	"./mx/EN/bg_p120.jpg": 7546,
	"./mx/EN/bg_p123.jpg": 30342,
	"./mx/EN/bg_parity.png": 450,
	"./mx/EN/fjf.gif": 41928,
	"./mx/EN/logo.png": 44266,
	"./mx/EN/play.gif": 92489,
	"./mx/EN/toplogo.png": 68416,
	"./mx/ES/bg-lose.png": 72010,
	"./mx/ES/bg-win.png": 54096,
	"./mx/ES/bg03-a.png": 23752,
	"./mx/ES/bg03.png": 89121,
	"./mx/ES/bg05c.jpg": 91419,
	"./mx/ES/bg105.png": 18800,
	"./mx/ES/bg115.png": 71840,
	"./mx/ES/bg116.png": 71717,
	"./mx/ES/bg117.png": 88547,
	"./mx/ES/bg13.png": 28882,
	"./mx/ES/bg131.png": 39937,
	"./mx/ES/bg132.png": 17436,
	"./mx/ES/bg142.png": 47355,
	"./mx/ES/bg143.png": 9503,
	"./mx/ES/bg147.jpg": 72673,
	"./mx/ES/bg148.jpg": 66718,
	"./mx/ES/bg149.jpg": 62342,
	"./mx/ES/bg150.jpg": 60594,
	"./mx/ES/bg155.jpg": 98868,
	"./mx/ES/bg53.png": 43490,
	"./mx/ES/bg54.jpg": 84300,
	"./mx/ES/bg55.png": 51438,
	"./mx/ES/bg59.png": 19790,
	"./mx/ES/bg62.png": 81434,
	"./mx/ES/bg67.png": 42447,
	"./mx/ES/bg67b.png": 11290,
	"./mx/ES/bg67c.png": 51273,
	"./mx/ES/bg68.jpg": 76738,
	"./mx/ES/bg69.jpg": 86833,
	"./mx/ES/bg70.jpg": 56879,
	"./mx/ES/bg76.png": 65635,
	"./mx/ES/bg79.jpg": 71021,
	"./mx/ES/bg903.jpg": 27074,
	"./mx/ES/bg_crash.png": 81718,
	"./mx/ES/bg_mine.png": 50387,
	"./mx/ES/bg_p115.jpg": 99009,
	"./mx/ES/bg_p117.jpg": 67330,
	"./mx/ES/bg_p118.jpg": 66799,
	"./mx/ES/bg_p119.jpg": 9844,
	"./mx/ES/bg_p120.jpg": 38389,
	"./mx/ES/bg_p123.jpg": 44218,
	"./mx/ES/bg_parity.png": 5749,
	"./mx/ES/fjf.gif": 51594,
	"./mx/ES/logo.png": 22296,
	"./mx/ES/play.gif": 3196,
	"./mx/ES/toplogo.png": 12537,
	"./ng/EN/S1/avatar/a1.png": 57470,
	"./ng/EN/S1/avatar/a2.png": 49547,
	"./ng/EN/S1/avatar/a3.png": 16396,
	"./ng/EN/S1/avatar/a4.png": 54692,
	"./ng/EN/S1/avatar/a5.png": 26509,
	"./ng/EN/S1/avatar/a6.png": 11334,
	"./ng/EN/S1/avatar/a7.png": 15398,
	"./ng/EN/S1/avatar/a8.png": 36552,
	"./ng/EN/S1/avatar/a9.png": 98654,
	"./ng/EN/S1/bg03-a.png": 12265,
	"./ng/EN/S1/bg03.png": 11803,
	"./ng/EN/S1/bg07.png": 61083,
	"./ng/EN/S1/bg07b.png": 57874,
	"./ng/EN/S1/bg105.png": 43897,
	"./ng/EN/S1/bg115.png": 60713,
	"./ng/EN/S1/bg116.png": 50910,
	"./ng/EN/S1/bg117.png": 29426,
	"./ng/EN/S1/bg128.png": 34928,
	"./ng/EN/S1/bg129.png": 93727,
	"./ng/EN/S1/bg13.png": 81266,
	"./ng/EN/S1/bg130.png": 70595,
	"./ng/EN/S1/bg131.png": 34922,
	"./ng/EN/S1/bg145.jpg": 14399,
	"./ng/EN/S1/bg147.jpg": 25745,
	"./ng/EN/S1/bg148.jpg": 65093,
	"./ng/EN/S1/bg149.jpg": 55094,
	"./ng/EN/S1/bg150.jpg": 96802,
	"./ng/EN/S1/bg155.jpg": 6876,
	"./ng/EN/S1/bg180.jpg": 37668,
	"./ng/EN/S1/bg180s.jpg": 3539,
	"./ng/EN/S1/bg180w.jpg": 45988,
	"./ng/EN/S1/bg181.jpg": 28808,
	"./ng/EN/S1/bg182.jpg": 63612,
	"./ng/EN/S1/bg184.png": 69938,
	"./ng/EN/S1/bg185.png": 79693,
	"./ng/EN/S1/bg20.jpg": 42002,
	"./ng/EN/S1/bg301.png": 87240,
	"./ng/EN/S1/bg53.png": 73561,
	"./ng/EN/S1/bg62.png": 91922,
	"./ng/EN/S1/bg67.png": 52548,
	"./ng/EN/S1/bg67b.png": 6148,
	"./ng/EN/S1/bg67c.png": 99560,
	"./ng/EN/S1/bg68.jpg": 65135,
	"./ng/EN/S1/bg69.jpg": 41281,
	"./ng/EN/S1/bg70.jpg": 99598,
	"./ng/EN/S1/bg76.png": 88397,
	"./ng/EN/S1/bg_p115.jpg": 85064,
	"./ng/EN/S1/bg_p117.jpg": 57266,
	"./ng/EN/S1/bg_p118.jpg": 60443,
	"./ng/EN/S1/bg_p119.jpg": 45670,
	"./ng/EN/S1/bg_p120.jpg": 4716,
	"./ng/EN/S1/bg_p123.jpg": 86775,
	"./ng/EN/S1/bg_p125.jpg": 70381,
	"./ng/EN/S1/bigwin.png": 85419,
	"./ng/EN/S1/fj.png": 57555,
	"./ng/EN/S1/fj2.png": 75138,
	"./ng/EN/S1/fjbg.jpg": 27775,
	"./ng/EN/S1/fjbg2.jpg": 77553,
	"./ng/EN/S1/fjbg6.png": 49977,
	"./ng/EN/S1/fjd.gif": 52806,
	"./ng/EN/S1/gm1.png": 34223,
	"./ng/EN/S1/gm2.png": 10030,
	"./ng/EN/S1/gm3.png": 70558,
	"./ng/EN/S1/gm4.png": 37318,
	"./ng/EN/bg-lose.png": 79505,
	"./ng/EN/bg-win.png": 4114,
	"./ng/EN/bg03-a.png": 11927,
	"./ng/EN/bg03.png": 69139,
	"./ng/EN/bg05c.jpg": 88891,
	"./ng/EN/bg105.png": 73182,
	"./ng/EN/bg115.png": 91466,
	"./ng/EN/bg116.png": 85865,
	"./ng/EN/bg117.png": 55258,
	"./ng/EN/bg13.png": 87318,
	"./ng/EN/bg131.png": 98735,
	"./ng/EN/bg132.png": 92525,
	"./ng/EN/bg142.png": 80929,
	"./ng/EN/bg143.png": 66703,
	"./ng/EN/bg147.jpg": 83039,
	"./ng/EN/bg148.jpg": 30373,
	"./ng/EN/bg149.jpg": 42175,
	"./ng/EN/bg150.jpg": 48904,
	"./ng/EN/bg155.jpg": 96845,
	"./ng/EN/bg53.png": 49296,
	"./ng/EN/bg54.jpg": 94412,
	"./ng/EN/bg55.png": 86485,
	"./ng/EN/bg59.png": 48389,
	"./ng/EN/bg62.png": 23709,
	"./ng/EN/bg67.png": 23954,
	"./ng/EN/bg67b.png": 69350,
	"./ng/EN/bg67c.png": 9513,
	"./ng/EN/bg68.jpg": 8977,
	"./ng/EN/bg69.jpg": 9496,
	"./ng/EN/bg70.jpg": 87800,
	"./ng/EN/bg76.png": 17141,
	"./ng/EN/bg79.jpg": 22894,
	"./ng/EN/bg903.jpg": 18563,
	"./ng/EN/bg_crash.png": 75934,
	"./ng/EN/bg_mine.png": 10176,
	"./ng/EN/bg_p115.jpg": 11211,
	"./ng/EN/bg_p117.jpg": 95825,
	"./ng/EN/bg_p118.jpg": 44785,
	"./ng/EN/bg_p119.jpg": 17439,
	"./ng/EN/bg_p120.jpg": 83551,
	"./ng/EN/bg_p123.jpg": 78127,
	"./ng/EN/bg_parity.png": 65224,
	"./ng/EN/fjf.gif": 14278,
	"./ng/EN/logo.png": 61957,
	"./ng/EN/play.gif": 55491,
	"./ng/EN/toplogo.png": 96257,
	"./ph/EN/S1/avatar/a1.png": 12728,
	"./ph/EN/S1/avatar/a2.png": 99405,
	"./ph/EN/S1/avatar/a3.png": 36920,
	"./ph/EN/S1/avatar/a4.png": 24231,
	"./ph/EN/S1/avatar/a5.png": 79336,
	"./ph/EN/S1/avatar/a6.png": 29327,
	"./ph/EN/S1/avatar/a7.png": 86677,
	"./ph/EN/S1/avatar/a8.png": 11298,
	"./ph/EN/S1/avatar/a9.png": 7199,
	"./ph/EN/S1/bg03-a.png": 66848,
	"./ph/EN/S1/bg03.png": 77817,
	"./ph/EN/S1/bg07.png": 12631,
	"./ph/EN/S1/bg07b.png": 15656,
	"./ph/EN/S1/bg105.png": 74111,
	"./ph/EN/S1/bg115.png": 78875,
	"./ph/EN/S1/bg116.png": 99048,
	"./ph/EN/S1/bg117.png": 34945,
	"./ph/EN/S1/bg128.png": 36175,
	"./ph/EN/S1/bg129.png": 15517,
	"./ph/EN/S1/bg13.png": 61556,
	"./ph/EN/S1/bg130.png": 23842,
	"./ph/EN/S1/bg131.png": 67109,
	"./ph/EN/S1/bg132.png": 65197,
	"./ph/EN/S1/bg145.jpg": 64908,
	"./ph/EN/S1/bg147.jpg": 84865,
	"./ph/EN/S1/bg148.jpg": 42677,
	"./ph/EN/S1/bg149.jpg": 14185,
	"./ph/EN/S1/bg150.jpg": 38426,
	"./ph/EN/S1/bg155.jpg": 28455,
	"./ph/EN/S1/bg180.jpg": 27666,
	"./ph/EN/S1/bg180s.jpg": 22191,
	"./ph/EN/S1/bg180w.jpg": 78109,
	"./ph/EN/S1/bg181.jpg": 33201,
	"./ph/EN/S1/bg182.jpg": 33236,
	"./ph/EN/S1/bg184.png": 73532,
	"./ph/EN/S1/bg185.png": 83309,
	"./ph/EN/S1/bg20.jpg": 33528,
	"./ph/EN/S1/bg300.png": 88486,
	"./ph/EN/S1/bg301.png": 7722,
	"./ph/EN/S1/bg53.png": 69373,
	"./ph/EN/S1/bg62.png": 6741,
	"./ph/EN/S1/bg67.png": 61164,
	"./ph/EN/S1/bg67b.png": 38902,
	"./ph/EN/S1/bg67c.png": 15298,
	"./ph/EN/S1/bg68.jpg": 22603,
	"./ph/EN/S1/bg69.jpg": 93186,
	"./ph/EN/S1/bg70.jpg": 28384,
	"./ph/EN/S1/bg76.png": 72344,
	"./ph/EN/S1/bg_p115.jpg": 25604,
	"./ph/EN/S1/bg_p117.jpg": 67165,
	"./ph/EN/S1/bg_p118.jpg": 40413,
	"./ph/EN/S1/bg_p119.jpg": 88573,
	"./ph/EN/S1/bg_p120.jpg": 75322,
	"./ph/EN/S1/bg_p123.jpg": 15705,
	"./ph/EN/S1/bg_p125.jpg": 19732,
	"./ph/EN/S1/bigwin.png": 43795,
	"./ph/EN/S1/fj.png": 12512,
	"./ph/EN/S1/fj2.png": 88861,
	"./ph/EN/S1/fjbg.jpg": 17753,
	"./ph/EN/S1/fjbg2.jpg": 13302,
	"./ph/EN/S1/fjbg6.png": 47086,
	"./ph/EN/S1/gm1.png": 14233,
	"./ph/EN/S1/gm2.png": 99227,
	"./ph/EN/S1/gm3.png": 30741,
	"./ph/EN/S1/gm4.png": 16171,
	"./ph/EN/S1/gm5.png": 10425,
	"./ph/EN/S1/gm6.png": 6913,
	"./ph/EN/S2/bigwin.png": 23399,
	"./ph/EN/S2/fj.png": 34366,
	"./ph/EN/S2/fj2.png": 46176,
	"./ph/EN/S2/fjbg.jpg": 56333,
	"./ph/EN/S2/fjbg2.jpg": 34436,
	"./ph/EN/S2/fjbg6.png": 92360,
	"./ph/EN/S2/fjd.gif": 86675,
	"./ph/EN/bg-lose.png": 81087,
	"./ph/EN/bg-win.png": 332,
	"./ph/EN/bg03-a.png": 90287,
	"./ph/EN/bg03.png": 88367,
	"./ph/EN/bg05c.jpg": 22060,
	"./ph/EN/bg105.png": 40335,
	"./ph/EN/bg115.png": 35492,
	"./ph/EN/bg116.png": 5644,
	"./ph/EN/bg117.png": 22482,
	"./ph/EN/bg13.png": 28834,
	"./ph/EN/bg131.png": 88787,
	"./ph/EN/bg132.png": 38078,
	"./ph/EN/bg142.png": 28411,
	"./ph/EN/bg143.png": 53403,
	"./ph/EN/bg147.jpg": 63140,
	"./ph/EN/bg148.jpg": 79660,
	"./ph/EN/bg149.jpg": 22473,
	"./ph/EN/bg150.jpg": 37648,
	"./ph/EN/bg155.jpg": 77523,
	"./ph/EN/bg53.png": 87727,
	"./ph/EN/bg54.jpg": 9426,
	"./ph/EN/bg55.png": 12313,
	"./ph/EN/bg59.png": 48815,
	"./ph/EN/bg62.png": 69690,
	"./ph/EN/bg67.png": 46643,
	"./ph/EN/bg67b.png": 60516,
	"./ph/EN/bg67c.png": 55669,
	"./ph/EN/bg68.jpg": 66973,
	"./ph/EN/bg69.jpg": 26156,
	"./ph/EN/bg70.jpg": 62901,
	"./ph/EN/bg76.png": 86770,
	"./ph/EN/bg79.jpg": 37378,
	"./ph/EN/bg903.jpg": 3780,
	"./ph/EN/bg_crash.png": 16198,
	"./ph/EN/bg_mine.png": 22787,
	"./ph/EN/bg_p115.jpg": 325,
	"./ph/EN/bg_p117.jpg": 25403,
	"./ph/EN/bg_p118.jpg": 28911,
	"./ph/EN/bg_p119.jpg": 89626,
	"./ph/EN/bg_p120.jpg": 71937,
	"./ph/EN/bg_p123.jpg": 29029,
	"./ph/EN/bg_parity.png": 31994,
	"./ph/EN/fjf.gif": 45035,
	"./ph/EN/logo.png": 88851,
	"./ph/EN/play.gif": 53902,
	"./ph/EN/toplogo.png": 58057,
	"./pk1.png": 48442,
	"./pk2.png": 60991,
	"./pk3.png": 85900,
	"./pk4.png": 71630,
	"./pk5.png": 59424,
	"./user1.png": 57354,
	"./user2.png": 20781,
	"./viponly.png": 94347,
	"./vn/VI/S1/avatar/a1.png": 56180,
	"./vn/VI/S1/avatar/a2.png": 61805,
	"./vn/VI/S1/avatar/a3.png": 54200,
	"./vn/VI/S1/avatar/a4.png": 76911,
	"./vn/VI/S1/avatar/a5.png": 90418,
	"./vn/VI/S1/avatar/a6.png": 72104,
	"./vn/VI/S1/avatar/a7.png": 56987,
	"./vn/VI/S1/avatar/a8.png": 48583,
	"./vn/VI/S1/avatar/a9.png": 99341,
	"./vn/VI/S1/bg03-a.png": 20963,
	"./vn/VI/S1/bg03.png": 32561,
	"./vn/VI/S1/bg07.png": 19714,
	"./vn/VI/S1/bg07b.png": 61225,
	"./vn/VI/S1/bg105.png": 78932,
	"./vn/VI/S1/bg115.png": 82393,
	"./vn/VI/S1/bg116.png": 6893,
	"./vn/VI/S1/bg117.png": 7594,
	"./vn/VI/S1/bg128.png": 81421,
	"./vn/VI/S1/bg129.png": 70684,
	"./vn/VI/S1/bg13.png": 64946,
	"./vn/VI/S1/bg130.png": 50390,
	"./vn/VI/S1/bg145.jpg": 95253,
	"./vn/VI/S1/bg147.jpg": 27437,
	"./vn/VI/S1/bg148.jpg": 6485,
	"./vn/VI/S1/bg149.jpg": 92708,
	"./vn/VI/S1/bg150.jpg": 40537,
	"./vn/VI/S1/bg152-w.png": 9276,
	"./vn/VI/S1/bg155.jpg": 66739,
	"./vn/VI/S1/bg180.jpg": 1132,
	"./vn/VI/S1/bg180s.jpg": 14971,
	"./vn/VI/S1/bg180w.jpg": 15138,
	"./vn/VI/S1/bg181.jpg": 94259,
	"./vn/VI/S1/bg182.jpg": 59404,
	"./vn/VI/S1/bg184.png": 86946,
	"./vn/VI/S1/bg185.png": 15834,
	"./vn/VI/S1/bg20.jpg": 95120,
	"./vn/VI/S1/bg300.png": 54384,
	"./vn/VI/S1/bg301.png": 24731,
	"./vn/VI/S1/bg53.png": 93160,
	"./vn/VI/S1/bg62.png": 20330,
	"./vn/VI/S1/bg67.png": 42560,
	"./vn/VI/S1/bg67b.png": 71380,
	"./vn/VI/S1/bg67c.png": 66229,
	"./vn/VI/S1/bg68.jpg": 83865,
	"./vn/VI/S1/bg69.jpg": 78171,
	"./vn/VI/S1/bg70.jpg": 26023,
	"./vn/VI/S1/bg76.png": 83506,
	"./vn/VI/S1/bg_p115.jpg": 39356,
	"./vn/VI/S1/bg_p117.jpg": 11773,
	"./vn/VI/S1/bg_p118.jpg": 61678,
	"./vn/VI/S1/bg_p119.jpg": 2733,
	"./vn/VI/S1/bg_p120.jpg": 33111,
	"./vn/VI/S1/bg_p123.jpg": 74702,
	"./vn/VI/S1/bg_p125.jpg": 28614,
	"./vn/VI/S1/bigwin.png": 75125,
	"./vn/VI/S1/fj.png": 45892,
	"./vn/VI/S1/fj2.png": 57901,
	"./vn/VI/S1/fjbg.jpg": 44446,
	"./vn/VI/S1/fjbg2.jpg": 46975,
	"./vn/VI/S1/fjbg6.png": 34402,
	"./vn/VI/S1/fjd.gif": 24757,
	"./vn/VI/S1/gm1.png": 47387,
	"./vn/VI/S1/gm2.png": 56257,
	"./vn/VI/S1/gm3.png": 37442,
	"./vn/VI/S1/gm4.png": 73969,
	"./vn/VI/S1/gm5.png": 34074,
	"./vn/VI/S1/gm6.png": 32335,
	"./vn/VI/S1/play.gif": 98791,
	"./vn/VI/bg-lose.png": 52824,
	"./vn/VI/bg-win.png": 50518,
	"./vn/VI/bg05c.jpg": 39844,
	"./vn/VI/bg115.png": 47428,
	"./vn/VI/bg116.png": 43777,
	"./vn/VI/bg117.png": 13522,
	"./vn/VI/bg13.png": 15082,
	"./vn/VI/bg131.png": 34839,
	"./vn/VI/bg132.png": 48265,
	"./vn/VI/bg142.png": 92434,
	"./vn/VI/bg143.png": 37898,
	"./vn/VI/bg54.jpg": 24961,
	"./vn/VI/bg54的副本.jpg": 11026,
	"./vn/VI/bg55.png": 67199,
	"./vn/VI/bg59.png": 84418,
	"./vn/VI/bg62.png": 97674,
	"./vn/VI/bg79.jpg": 72699,
	"./vn/VI/bg903.jpg": 72005,
	"./vn/VI/bg904.jpg": 51543,
	"./vn/VI/bg_crash.png": 507,
	"./vn/VI/bg_mine.png": 30952,
	"./vn/VI/bg_parity.png": 15217,
	"./vn/VI/bg_wheel.png": 52763,
	"./vn/VI/fjf.gif": 92043,
	"./vn/VI/play.gif": 72261,
	"./vn/VI/toplogo.png": 51824,
	"./wifi-g.png": 43039,
	"./wifi-o.png": 88221,
	"./wifi-r.png": 2975,
	"./yes.png": 98139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;